import axios from 'axios';

export default async (data) => axios.post(`${process.env.VUE_APP_API_ENDPOINT}/freshdesk-screenshot-uploader`, data);
